import Image from 'next/image';

import Pattern from '@public/images/pattern.png';

import styles from './unavailable-site-poster.module.css';

export const UnavailableSitePoster = ({ isMobile }: { isMobile: boolean }) => (
    <div className={`${styles.posterWrapper} ${isMobile ? styles.isMobile : ''}`}>
        {!isMobile && <Image className={styles.pattern} src={Pattern} alt={'pattern'} />}
        <h2 className={`${styles.title} ${isMobile ? styles.isMobile : ''}`}>Сайт временно не работает, приносим свои извинения</h2>
        {!isMobile && <Image className={styles.pattern} src={Pattern} alt={'pattern'} />}
    </div>
);
